import { Theme } from '@mirai/ui';

const WIDTH = '394px';

export const getStyle = () => {
  const {
    accent,
    accentBorder,
    accentLight,
    borderRadius,
    buttonBackground,
    buttonBackgroundActive,
    buttonColor,
    content,
    contentBackground,
    contentBorder,
    contentLight,
    error,
    info,
  } = Theme.get();

  return {
    button: {
      backgroundColor: buttonBackground,
      textColor: buttonColor,
      hover: { backgroundColor: buttonBackgroundActive },
    },
    infoBanner: { backgroundColor: info, iconColor: info },
    input: { error: { textColor: error, borderColor: error } },
    global: {
      borderRadius,
      container: { width: WIDTH },
      textColorPrimary: content,
      textColorSecondary: contentLight,
    },
    selected: { backgroundColor: contentBackground, borderColor: accentBorder },
    spinner: { primaryColor: accent, secondaryColor: accentLight, tertiaryColor: accentBorder },
    unselected: { borderColor: contentBorder },
  };
};
